import { Link, useNavigate } from "react-router-dom";
import useSiteMenuClone from "../components/helpers/navbar";
import { useEffect, useState } from "react";

export default function Navbar(props){
	const [suggestions, setSuggestions] = useState([]);
	const [showSuggestions, setShowSuggestions] = useState(false);

	useEffect(() => {
		const searchWrapper = document.querySelector(".nav2_bar_search-input");
		const inputBox = searchWrapper.querySelector("input");
		const suggBox = searchWrapper.querySelector(".nav2_bar_autocom-box");
		const icon = searchWrapper.querySelector(".nav2_bar_icon");
	  
		const handleKeyUp = (e) => {
			
		  let userData = e.target.value.trim(); // user entered data
		  
		  let emptyArray = [];
		  if (userData) {
			emptyArray = suggestions.filter((data) => {
			  // filtering array value and user characters to lowercase and return only those words which start with user entered chars
			  return data.toLowerCase().startsWith(userData.toLowerCase());
			});
			if(emptyArray.length < 1){
				emptyArray.push(`${userData}`);
			}
			emptyArray = emptyArray.map((data) => {
			  // passing return data inside li tag
			  return (data = "<li>" + data + "</li>");
			});
			searchWrapper.classList.add("nav2_bar_active");
			// show autocomplete box
			// setShowSuggestions(emptyArray);
	  
			let allList = suggBox.querySelectorAll("li");
			for (let i = 0; i < allList.length; i++) {
			  // adding onclick attribute in all li tag
			  allList[i].addEventListener("click", () => select(allList[i]));
			}

		  } else {
			searchWrapper.classList.remove("nav2_bar_active"); // hide autocomplete box
			setShowSuggestions([userData]); // Add the value to the suggestions
		  }
		};
	  
		const select = (element) => {
		  let selectData = element.textContent;
		  inputBox.value = selectData;
		  searchWrapper.classList.remove("nav2_bar_active");
		};
	  
		inputBox.addEventListener("keyup", handleKeyUp);
	  
		// Clean up the event listener when the component unmounts
		return () => {
		  inputBox.removeEventListener("keyup", handleKeyUp);
		};
	  }, [suggestions]);
	  


  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();


  const handleSearch = (event) => {
    event.preventDefault();
    if (searchQuery.trim() !== '') {
      // Redirect to the search results page with the search query as a parameter
      navigate(`/animal_detail?q=${encodeURIComponent(searchQuery)}`);
    }

};

  const fetchSuggestions = async (query) => {
  	try {
  	const response = await fetch(`https://biouniverse-api.vercel.app/search/suggestions?query=${query}`);
  	const data = await response.json();
  	setSuggestions(data);
  	} catch (error) {
  	console.error('Error fetching suggestions:', error);
  	}
  };

  useEffect(() => {
    fetchSuggestions(searchQuery);
  }, [searchQuery]);


  const handleInputChange = (event) => {
	const test = '~`!@#$%^&*()[]{}-_+=:;\'"\\|?/.>,<'
	if(test.includes(event.nativeEvent.data)){
		return
	}else{
		setSearchQuery(event.target.value);
	}
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleSearch(event);
	  handleReload();
    }
  };

  const handleIconClick = (event) => {
	  handleSearch(event);
	  handleReload();
  };

	const handleReload = () => {
	  window.location.reload();
	};


	useEffect(() => {
		// List of JS files to reload
		const jsFiles = [
		  'assets/js/custom.js',
		];
	
		// Create script elements for each JS file
		jsFiles.forEach((filePath) => {
		  const script = document.createElement('script');
		  script.src = filePath;
		  script.async = true;
		  document.body.appendChild(script);
		});
	
		// Clean up the script elements when the component unmounts
		return () => {
		  jsFiles.forEach((filePath) => {
			const script = document.querySelector(`[src="${filePath}"]`);
			if (script) {
			  document.body.removeChild(script);
			}
		  });
		};
	  }, []);

	const styless = {
		backgroundColor: props.style || ''
	};

	const { cloneMenu, setIsMenuCloned } = useSiteMenuClone();

	const handleButtonClick = () => {
	  // Call the cloneMenu function to clone the menu
	  setIsMenuCloned(true);
	};

    return(
        <>
		    <div className="site-mobile-menu site-navbar-target">
		<div className="site-mobile-menu-header">
			<div className="site-mobile-menu-close">
				<span className="icofont-close js-menu-toggle"></span>
			</div>
		</div>
		<div className="site-mobile-menu-body"></div>
	</div>
        	
				<nav className={"transparent" === props.transparent ? "site-nav": "site-nav navbar-fixed-top" } style={styless}>
						<div className="container">
							<div className="site-navigation">
								<Link to="/home" className="logo m-0">
								<div className="contact_logo" style={{display: 'inline-block', marginRight: 0, position: 'relative', bottom: '2px', left: '2px'}}>
									<img src="assets/Contactuus/images/Company-forDark.gif" alt="Company dark logo" title="Encyclopedia"/>
								</div>
									BioUniverse <span className="binduColor" style={{color: 'white'}}>.</span></Link>

					{/* search bar  */}

					<div className="nav2_bar_wrapper">
  <div className="nav2_bar_search-input">
    <a href="" target="_blank" hidden></a>
    <input type="search"
							autoComplete="off"
							required
							value={searchQuery}
							onChange={handleInputChange}
							onKeyUp={handleKeyPress} 
							placeholder="Type to search.."
							id="nav2_input"/>
    <div className="nav2_bar_autocom-box">
	{(Array.isArray(suggestions) && suggestions.length > 0 && searchQuery !== '') ? (
  <>
    {suggestions.map((suggestion) => (
      <li key={suggestion} onClick={() => setSearchQuery(suggestion)}>
        {suggestion}
      </li>
    ))}
  </>
) : ('')}
    </div>
    <div className="nav2_bar_icon" onClick={handleIconClick}><i className="fas fa-search"></i></div>
  </div>
</div>
								
						{/* <div className="nav_bar_search">
						<input
							type="search"
							autoComplete="off"
							required
							value={searchQuery}
							onChange={handleInputChange}
							onKeyUp={handleKeyPress} // Handle Enter key press
						/>
						{(Array.isArray(suggestions) && suggestions.length > 0 && searchQuery !== '') ? (
  <ul>
    {suggestions.map((suggestion) => (
      <li key={suggestion} onClick={() => setSearchQuery(suggestion)}>
        {suggestion}
      </li>
    ))}
  </ul>
) : ('')}
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="-20 -20 1000 150">
							<path className="nav_bar_path" fill="none" d="M924.4 85.2c-19.5 19.5-50.8 19.7-70.3 0-19.3-19.4-19.3-51 .3-70.6 19.5-19.5 51-19.4 70.6 0 19.3 19.7 19.3 50.8-.5 70.6l35.4 35.3H0"/>
						</svg>
						</div> */}
								


								
								<ul className="js-clone-nav d-none d-lg-inline-block text-left site-menu float-right">
									<li className={'home' === props.active ? 'active' : ''}><Link to="/home">Home</Link></li>
									<li className={'about' === props.active ? 'active' : ''}><Link to="/about">About</Link></li>
									<li className={'contact' === props.active ? 'active' : ''}><Link to="/contact">Contact Us</Link></li>
									<li className={'dropdown' === props.active ? ' active has-children' : 'has-children'}>
										<a href="#">Dropdown</a>
										<ul className="dropdown">
											<li className='has-children'>
												<a href="#">Categories</a>
												<ul className="dropdown">
													<li><Link to='/category_amphibian' >Amphibians</Link></li>
													<li><Link to='/category_birds'     >Birds</Link></li>
													<li><Link to='/category_mammals'   >Mammals</Link></li>
													<li><Link to='/category_marines'   >Marines</Link></li>
													<li><Link to='/category_reptiles'  >Reptiles</Link></li>
													<li><Link to='/category_endangered'>Endangered</Link></li>
												</ul>
											</li>
											<li><Link to="/article">Article</Link></li>
											<li><Link to="/gallery">Gallery</Link></li>
										</ul>
									</li>
									<li className={"login" === props.active ? 'active' : ""}><Link to="/register">Login</Link></li>
								</ul>
				
								<Link to="" className="burger ml-auto float-right site-menu-toggle js-menu-toggle d-inline-block d-lg-none light" data-toggle="collapse" data-target="#main-navbar" onClick={handleButtonClick}>
									<span></span>
								</Link>
				
							</div>
						</div>
					</nav>
        </>
    );
}